<template>
  <div class="containerPage">
    <div class="page">
      <!-- <button> 
                <img src="image/icon/care.svg" alt="">
            </button>
            <div>
                <h3>{{ pages }}</h3>
            </div>
            <button>
                <img src="image/icon/care.svg" alt="">
            </button> -->
      {{ currentPage }}
      <button @click="back">Init</button>
      <button @click="$emit('backButton')">Back</button>
      <button @click="$emit('nextButton')">Next</button>
    </div>
  </div>
</template>
  
  <script>
export default {
  //   props: {
  //     currentPage: {
  //       type: Number,
  //       required: true,
  //     },
  //     qtdTotal: {
  //       type: Number,
  //       required: true,
  //     },
  //     listAllClients: {
  //       type: Function,
  //       required: true,
  //     },
  //   },
  data() {
    return {
      pages: 1,
    };
  },
  //   methods: {
  //     async next() {
  //       this.currentPage += 10;

  //       if (this.qtdTotal <= this.currentPage) {
  //         console.log("parar");
  //       }
  //     },
  //   },
};
</script>
  <style scoped>
.containerPage {
  height: 5rem;
  display: flex;
  justify-content: end;
}

.containerPage .page {
  display: flex;
  align-items: center;
  width: fit-content;
}

.page div {
  width: 3rem;
  display: flex;
  justify-content: center;
}

.containerPage button {
  border-radius: 50%;
  min-width: 2rem;
  height: 2rem;
  border: none;
  padding: 0.2rem;
  cursor: pointer;
}

.containerPage button:hover {
  filter: brightness(0.8);
}

.containerPage button img {
  height: 100%;
}

.containerPage button:nth-child(1) img {
  transform: rotateZ(180deg);
}
</style>
